import { useCallback, useEffect, useState } from "react";
import { ArrowUpRight, ArrowDownRight, Wallet } from "lucide-react";
import { api } from "@/lib/api";
import { rupiah, tanggal } from "@/lib/format";
import CrudPage from "@/components/admin/CrudPage";
import { StatCard } from "@/components/admin/StatCard";
import { Badge } from "@/components/ui/badge";

const today = new Date().toISOString().slice(0, 10);

const fields = [
  { name: "type", label: "Jenis", type: "select", required: true, options: [{ value: "masuk", label: "Kas Masuk" }, { value: "keluar", label: "Kas Keluar" }] },
  { name: "date", label: "Tanggal", type: "date", required: true },
  { name: "category", label: "Kategori", required: true, placeholder: "Infaq Jumat, Listrik, Honor..." },
  { name: "amount", label: "Nominal (Rp)", type: "number", required: true },
  { name: "description", label: "Keterangan", type: "textarea" },
];

const columns = [
  { key: "date", label: "Tanggal", render: (t) => tanggal(t.date) },
  { key: "type", label: "Jenis", render: (t) => <Badge className={t.type === "masuk" ? "bg-emerald-100 text-emerald-800 hover:bg-emerald-100" : "bg-red-100 text-red-800 hover:bg-red-100"}>{t.type === "masuk" ? "Masuk" : "Keluar"}</Badge> },
  { key: "category", label: "Kategori" },
  { key: "description", label: "Keterangan", className: "max-w-xs truncate text-slate-500" },
  { key: "amount", label: "Nominal", className: "text-right font-semibold", render: (t) => <span className={t.type === "masuk" ? "text-emerald-700" : "text-red-700"}>{rupiah(t.amount)}</span> },
];

export default function Keuangan() {
  const [summary, setSummary] = useState(null);
  const loadSummary = useCallback(() => api.get("/finance/summary").then((r) => setSummary(r.data)).catch(() => {}), []);
  useEffect(() => {
    loadSummary();
  }, [loadSummary]);

  return (
    <CrudPage
      title="Keuangan"
      subtitle="Catat pemasukan dan pengeluaran kas masjid"
      endpoint="transactions"
      prefix="admin-transaction"
      itemLabel="Transaksi"
      fields={fields}
      columns={columns}
      defaults={{ type: "masuk", date: today, category: "", amount: "", description: "" }}
      searchKeys={["category", "description", "type"]}
      onChanged={loadSummary}
      extraTop={
        <div className="grid sm:grid-cols-3 gap-4 mb-6">
          <StatCard label="Total Kas Masuk" value={rupiah(summary?.total_masuk)} icon={ArrowUpRight} tone="bg-emerald-50 text-emerald-700" testId="finance-masuk-card" />
          <StatCard label="Total Kas Keluar" value={rupiah(summary?.total_keluar)} icon={ArrowDownRight} tone="bg-red-50 text-red-700" testId="finance-keluar-card" />
          <StatCard label="Saldo Kas" value={rupiah(summary?.saldo)} icon={Wallet} tone="bg-[#f6ebd0] text-[#a8871f]" testId="finance-balance-card" />
        </div>
      }
    />
  );
}
